<template>
	<c-dialog ref="dialog" title="分润调拨接收" mode="slide" width="1000" enable-flex mask-close>
		<template #head>
			<div class="m-detail-tag flex-center-cross">
				<label class="transfer-code">{{transferData.transfer_code || '-'}}</label>
				<c-state tag dict="PROFIT_TRANSFER_STATE" :value="transferData.transfer_state"></c-state>
			</div>
		</template>

		<!-- 扫码接收 -->
		<div class="m-detail-body">

			<div class="m-head-grid">
				<div class="head-item"><label>调出商户</label><span>{{transferData.merchant_name || '-'}}</span></div>
				<div class="head-item"><label>分润比例</label><span>{{formatRatio(transferData.transfer_ratio)}}</span></div>
				<div class="head-item"><label>快递单号</label><span>{{transferData.express_no || '-'}}</span></div>
				<div class="head-item"><label>调拨数量</label><span>{{statData.total_qty || 0}}</span></div>
				<div class="head-item"><label>已接收</label><span class="z-received">{{statData.receive_qty || 0}}</span></div>
				<div class="head-item"><label>待接收</label><span class="z-diff">{{totalQty}}</span></div>
				<div class="head-item"><label>已扫描</label><span class="z-received">{{scannedList.length}}</span></div>
				<div class="head-item"><label>待扫描</label><span class="z-diff">{{totalQty - scannedList.length}}</span></div>
			</div>
			
			<!-- 供应商/供应商联系人（货款结算人）：仅首轮接收需选择，已选定的多轮接收只读展示 -->
			<div class="m-supplier-form">
				<template v-if="!hasSupplier">
					<div class="supplier-item">
						<label class="z-required">供应商</label>
						<c-select ref="supplierSelector" name="supplier_id" v-model="supplierId" async
						          @search="searchSupplier" @change="changeSupplier"
						          :value-data="supplierSelected"></c-select>
					</div>
					<div class="supplier-item">
						<label class="z-required">供应商联系人</label>
						<c-select ref="supplierContactSelector" name="supplier_contact_id" v-model="supplierContactId" async
						          :disabled="supplierId == 0"
						          @search="searchUser('2', arguments[0], arguments[1])"
						          :value-data="supplierContactSelected"></c-select>
						<span class="z-tip">作为货款结算人</span>
					</div>
				</template>
				<template v-else>
					<div class="supplier-item">
						<label>供应商</label>
						<span class="z-value">{{transferData.supplier_name || '-'}}</span>
					</div>
					<div class="supplier-item">
						<label>货款结算人</label>
						<span class="z-value">{{transferData.supplier_contact_realname || '-'}}</span>
					</div>
				</template>
			</div>

			<c-title>接收商品明细</c-title>
			<m-operate border>
				<c-input ref="codeInput" v-model="scanCode" placeholder="请扫描/输入到货背贴码" @keyup.enter.native="scanCodeHandle">
					<template #appendIcon><i class="tf-scan"></i></template>
				</c-input>
				<c-button color="main" @click="scanCodeHandle">确定</c-button>
				<c-button color="grey" :hollow="true" prepend-icon="tf-check" @click="receiveAll">全部接收</c-button>
			</m-operate>
			<c-table ref="productTable" :data="productList" border :paging="false">
				<template #empty>
					<c-empty message="暂无产品明细"></c-empty>
				</template>
				<c-table-column label="产品信息" width="500">
					<template #default="{data}">
						<m-product-info :name="data.product_info" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
					</template>
				</c-table-column>
				<c-table-column label="成本价" width="80">
					<template #default="{data}">{{data.cost_price ? '¥' + data.cost_price : '-'}}</template>
				</c-table-column>
				<c-table-column label="接收状态" width="80">
					<template #default="{data}">
						<span v-if="isScanned(data)" class="z-received"><i class="tf tf-check"></i> 已扫描</span>
						<span v-else class="z-pending">待扫描</span>
					</template>
				</c-table-column>
			</c-table>
		</div>

		<template #button>
			<c-button size="dialog" color="main" @click="confirmReceive">确定接收</c-button>
			<c-button size="dialog" @click="$refs.dialog.close()">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'profitTransferReceive',

		computed: {
			...mapState(['saasInfo', 'userInfo']),

			totalQty() {
				//后端只回待接收（pending）明细行
				return this.productList.length;
			},

			//是否已选定货款结算人（供应商联系人）：多轮接收时首轮已落库，只读展示
			hasSupplier() {
				return !!this.transferData.supplier_contact_id;
			}
		},

		data() {
			return {
				transferId: '',
				scanCode: '',
				transferData: {},
				statData: {},
				productList: [],
				scannedList: [],
				supplierId: 0,
				supplierContactId: 0,
				supplierSelected: [],
				supplierContactSelected: []
			}
		},

		methods: {
			/*********打开弹窗**********/
			open(id) {
				this.transferId = id;
				this.scanCode = '';
				this.transferData = {};
				this.statData = {};
				this.productList = [];
				this.scannedList = [];
				this.supplierId = 0;
				this.supplierContactId = 0;
				this.supplierSelected = [];
				this.supplierContactSelected = [];
				this.loadDetail();
				this.$refs.dialog.open();
				this.focusInput();
			},

			/*********加载接收详情**********/
			loadDetail() {
				this.request({
					url: '/profitTransfer/receive/detail',
					data: {id: this.transferId},
					loading: true,
					success: data => {
						this.transferData = (data && data.transfer) || {};
						this.statData = data || {};
						this.productList = (data && data.product_list) || [];
					},
					fail: (code, data, msg) => {
						this.$message({message: msg, type: 'error'});
						this.$refs.dialog.close();
						return false;
					}
				});
			},

			/*********聚焦扫码输入框**********/
			focusInput() {
				this.$nextTick(() => {
					var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
					if (input) input.focus();
				});
			},

			/*********扫码标记接收**********/
			scanCodeHandle() {
				var code = (this.scanCode || '').trim();
				if (!code) {
					this.$message({message: '请输入背贴码', type: 'warning'});
					return;
				}
				var row = this.productList.find(item => item.produce_unique_code == code);
				if (!row) {
					this.$message({message: '背贴码【' + code + '】不在本调拨单中', type: 'error'});
					this.scanCode = '';
					this.focusInput();
					return;
				}
				if (this.isScanned(row)) {
					this.$message({message: '背贴码【' + code + '】已扫描', type: 'warning'});
					this.scanCode = '';
					this.focusInput();
					return;
				}
				this.scannedList.push(row);
				this.scanCode = '';
				this.focusInput();
			},

			/*********全部接收**********/
			receiveAll() {
				this.scannedList = this.productList.slice();
			},

			/*********是否已扫描**********/
			isScanned(data) {
				return this.scannedList.some(item => item.produce_unique_code_id == data.produce_unique_code_id);
			},

			/*********分润比例展示**********/
			formatRatio(val) {
				if (val === null || val === undefined || val === '') {
					return '-';
				}
				return Number(val) + '%';
			},

			/*********搜索【供应商】下拉框信息**********/
			searchSupplier(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {options_code: 'SUPPLIER', keyword: keyword},
					success: data => {
						resolve(data);
					}
				});
			},

			/*********变更【供应商】：清空已选联系人**********/
			changeSupplier() {
				this.supplierContactId = 0;
				this.supplierContactSelected = [];
			},

			/*********搜索【供应商联系人】下拉框信息（user_type=2 供应商子账号）**********/
			searchUser(user_type, keyword, resolve) {
				var paramData = {user_type: user_type, options_code: 'SYSUSER', keyword: keyword};
				if (user_type == 2 && this.supplierId && this.supplierId != 0) {
					paramData.supplier_id = this.supplierId;
				}
				this.request({
					url: '/system/options',
					data: paramData,
					success: data => {
						resolve(data);
					}
				});
			},

			/*********确定接收**********/
			confirmReceive() {
				if (this.scannedList.length == 0) {
					this.$message({message: '请至少扫描一件到货商品', type: 'warning'});
					return;
				}
				//首轮接收必须选定供应商联系人（货款结算人）
				if (!this.hasSupplier && (!this.supplierContactId || this.supplierContactId == 0)) {
					this.$message({message: '请选择供应商联系人（货款结算人）', type: 'warning'});
					return;
				}
				var diff = this.totalQty - this.scannedList.length;
				var tip = diff > 0 ? '本次接收【' + this.scannedList.length + '】件，剩余未接收【' + diff + '】件可后续再接收，确认接收？'
						: '确认接收全部【' + this.scannedList.length + '】件未接收商品？';
				this.$confirm({
					message: tip,
					buttonName: '确定接收',
					cancelButton: true,
					resolve: () => {
						var reqData = {
							id: this.transferId,
							produce_unique_code_ids: this.scannedList.map(item => item.produce_unique_code_id)
						};
						//首轮接收携带供应商/供应商联系人（货款结算人）；多轮接收后端以已落库结算人为准
						if (!this.hasSupplier) {
							reqData.supplier_id = this.supplierId;
							reqData.supplier_contact_id = this.supplierContactId;
						}
						this.request({
							url: '/profitTransfer/receive/confirm',
							data: reqData,
							loading: true,
							success: res => {
								// 接收成功不再展示结果页：提示弹框告知接收计数，用户确认后关闭接收弹窗并刷新列表
								var d = res || {};
								this.$confirm({
									type: 'success',
									title: '接收成功',
									message: '本次接收【' + (d.receive_qty || 0) + '】件' + ((d.pending_qty || 0) ? '，剩余未接收【' + d.pending_qty + '】件' : ''),
									buttonName: '完成',
									cancelButton: false,
									resolve: () => {
										this.$refs.dialog.close();
										this.$emit('resolve');
									}
								});
							},
							fail: (code, data, msg) => {
								this.$message({message: msg, type: 'error'});
								return false;
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-tag {
		gap: 10px;

		.transfer-code {
			font-size: 13px;
			color: #666;
		}
	}

	.m-detail-body {
		padding: 0 16px;
	}

	.m-supplier-form {
		display: flex;
		flex-wrap: wrap;
		gap: 16px;
		padding: 10px 12px;
		margin-bottom: 12px;
		background: #fafafa;
		border-radius: 4px;

		.supplier-item {
			display: flex;
			align-items: center;
			min-width: 320px;
			flex: 1;
			font-size: 13px;

			label {
				width: 92px;
				flex-shrink: 0;
				color: #999;
				text-align: right;
				margin-right: 8px;

				&.z-required:before {
					content: '*';
					color: #f5222d;
					margin-right: 2px;
				}
			}

			.z-value {
				color: #333;
			}

			.z-tip {
				margin-left: 8px;
				color: #bbb;
				font-size: 12px;
				white-space: nowrap;
			}
		}
	}

	.m-head-grid {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;

		.head-item {
			width: 33.33%;
			padding: 6px 0;
			font-size: 13px;

			label {
				color: #999;
				margin-right: 8px;
			}

			span {
				color: #333;
			}

			.z-diff {
				color: #f5222d;
			}

			.z-received {
				color: #52c41a;
			}
		}
	}

	.z-received {
		color: #52c41a;
	}

	.z-pending {
		color: #999;
	}
</style>
